import { DocumentTypeCat } from '@ps/platform-message-framework/common/DocumentTypeCat';

export enum PersonalIdType {
  Unknown = 0,
  NationalId = 1,
  DriverLicense = 2,
  IdCard = 3,
  Passport = 4,
  SSN = 5,
  Other = 6
}

export const getPersonalIdType = (value: number) => {
  switch (true) {
    case value === DocumentTypeCat.DRIVERS_LICENSE:
      return PersonalIdType.DriverLicense;
    case value === DocumentTypeCat.NATIONAL_IDENTITY_CARD:
      return PersonalIdType.NationalId;
    case value === DocumentTypeCat.PASSPORT:
      return PersonalIdType.Passport;
    case value === DocumentTypeCat.OTHER:
      return PersonalIdType.Other;
  }
};
